/**
 * How a charge level is written. A car reports a battery percentage; a
 * charger only knows the energy it has delivered this session, which the
 * backend plans against an assumed capacity and reports as a synthetic
 * percentage of that capacity.
 */
export type LevelFormat =
  | { unit: 'percent' }
  | { unit: 'kwh'; capacityKwh: number }
  // A charger can't see the car's battery, so its card shows when it will
  // charge and what it costs, never a level
  | { unit: 'none' }

export const PERCENT_LEVEL: LevelFormat = { unit: 'percent' }

function formatKwh(kwh: number) {
  const rounded = kwh < 10 ? Math.round(kwh * 10) / 10 : Math.round(kwh)
  return `${rounded} kWh`
}

/** A level given as a percent of the target capacity, in the device's terms. */
export function formatLevel(percent: number, level: LevelFormat) {
  if (level.unit === 'none') {
    return ''
  }
  return level.unit === 'percent'
    ? `${Math.round(percent)}%`
    : formatKwh((percent / 100) * level.capacityKwh)
}

/** Top, middle and bottom labels for the session chart's y-axis. */
export function getLevelAxisLabels(level: LevelFormat) {
  if (level.unit === 'none') {
    return ['', '', '']
  }
  return level.unit === 'percent'
    ? ['100%', '50%', '0%']
    : [formatKwh(level.capacityKwh), formatKwh(level.capacityKwh / 2), '0']
}
